import { i18n } from "../../../translate/i18n";

// D8.9.2 — Constante + helper de validación de canales (extraídos del god file).

export const VPS_ALERTS_CHANNEL_ANCHOR_ID = "vps-alerts-canal-notificacion";

/**
 * Validación de canales (email / WhatsApp) según notificationType — misma regla que el guardado en servidor.
 */
export const buildChannelValidationMessages = (formData, validateEmailFn, validateWhatsAppNumberFn) => {
  const msgs = [];
  const t = formData.notificationType || "email";

  if (t === "email" || t === "both") {
    if (!formData.smtpConfigId) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.smtpSelect"));
    }
    if (!formData.adminEmail || !String(formData.adminEmail).trim()) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.adminEmailRequired"));
    } else if (!validateEmailFn(formData.adminEmail)) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.adminEmailInvalid"));
    }
  }

  if (t === "whatsapp" || t === "both") {
    if (!formData.whatsappId) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.whatsappSelect"));
    }
    if (!formData.adminWhatsapp || !String(formData.adminWhatsapp).trim()) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.adminWhatsappRequired"));
    } else if (!validateWhatsAppNumberFn(formData.adminWhatsapp)) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.adminWhatsappInvalid"));
    }
    if (!formData.whatsappMessageTemplate || !String(formData.whatsappMessageTemplate).trim()) {
      msgs.push(i18n.t("settings.vpsAlerts.validation.whatsappTemplateRequired"));
    }
  }

  return msgs;
};
